// extracted by mini-css-extract-plugin
export var fullGrid = "_2z-3";
export var pdpPreviewContainer = "_2z-1";
export var previewContainer = "_2z-0";
export var togglePreviewContainer = "_2z-2";